module.exports = __webpack_public_path__ + "assets/events_insult_primary.4d3e2cb4.svg";